import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { ReduxState } from 'kb-shared';
import { FEATURE_DEPOSIT_PROMO } from '../../config/features';
import { FlexCentered, typography, FullPageLoaderContainer } from '../../styled';
import BookCycle from './components/BookCycle';
import CycleConfirmation from './components/CycleConfirmation';
import Loader from '../../components/Loader/Loader';
import { History } from 'history';

import { themes } from 'kb-shared';
import PatientStripeProvider from 'hoc/PatientStripeProvider';
const { breakpoints, colors } = themes;

const {
  serif: {
    card: { H1 }
  }
} = typography;

const LoadingTitle = styled(H1)`
  margin-bottom: 40px;
`;

const Container = styled(FlexCentered)`
  margin-top: 100px;
`;

const Content = styled(FlexCentered)`
  flex-direction: column;
  margin: 0px 30px 0px 30px;
  max-width: 765px;

  @media (max-width: ${breakpoints.largePhonePortrait}) {
    width: 95%;
  }
`;

type Props = {
  depositPromoCode?: string;
  history: History;
  patientMembership?: {
    membershipId?: string;
    employer?: boolean;
  };
};

const CyclePayment = (props: Props) => {
  const [boughtCycle, setBoughtCycle] = useState();
  const [loading, setLoading] = useState(false);
  const { depositPromoCode, patientMembership, history } = props;

  useEffect(() => {
    const patientHasEmployerMembership =
      patientMembership && patientMembership.employer && patientMembership.membershipId;
    if (patientHasEmployerMembership) {
      history.push('/');
    }
  }, [patientMembership, history]);

  if (loading)
    return (
      <FullPageLoaderContainer>
        <LoadingTitle>Buying your cycle</LoadingTitle>
        <Loader color={colors.KBYellow} height={200} width={200} />
      </FullPageLoaderContainer>
    );

  return (
    <Container>
      <Content>
        <H1>
          {boughtCycle
            ? "You're all set!"
            : depositPromoCode
            ? `Submit your cycle deposit`
            : `Submit your cycle payment`}
        </H1>
        {!boughtCycle ? (
          <PatientStripeProvider>
            <BookCycle
              onSuccess={cycle => {
                // @ts-ignore
                setBoughtCycle(cycle.patientPackage);
                setLoading(false);
              }}
              onBook={() => {
                setLoading(true);
              }}
            />
          </PatientStripeProvider>
        ) : (
          <CycleConfirmation boughtCycle={boughtCycle} />
        )}
      </Content>
    </Container>
  );
};

const mapStateToProps = (state: ReduxState) => {
  return {
    depositPromoCode: state.features.features[FEATURE_DEPOSIT_PROMO],
    patientMembership: state.patient.patient.patientMembership
  };
};

export default connect(mapStateToProps)(CyclePayment);
